import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum HosDisciplineEnum {
    "Skilled Nursing" = 1,
    "Hospice Physician" = 4,
    "Medical Social Work" = 8,
    "Spiritual Counseling" = 16,
    "Bereavement Counseling" = 32,
    "Volunteer Coordinator" = 64,
    "Physical Therapy" = 128,
    "Occupational Therapy" = 256,
    "Speech Therapy" = 512,
    "Reiki" = 1024,
    "Music Therapy" = 2048,
    "Art Therapy" = 4096,
    "Massage Therapy" = 8192,
    "Aroma Therapy" = 16384,
    "Healing Touch" = 32768,
    "Hypnotherapy" = 65536,
    "Pet Therapy" = 131072,
    "Dietary Counseling" = 262144,
    "Volunteer" = 524288,
    "Hospice Aide" = 1048576,
    "Order" = 2097152,
    "Complementary Therapy" = 4194304,
    "Hospice Medical Director" = 8388608,
    "Physician’s Assistant" = 16777216,
    "Home Maker" = 33554432,
    "Nurse Practitioner" = 67108864
}

class HosDisciplineClass extends EnumWithDescription<HosDisciplineEnum> {
    public readonly enum = HosDisciplineEnum;
    public readonly enumName: string = "HosDisciplineEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HosDisciplineEnum>> = new Map([
        [
            "Skilled Nursing",
            {
                value: HosDisciplineEnum["Skilled Nursing"],
                name: "Skilled Nursing"
            }
        ],
        [
            "Hospice Physician",
            {
                name: "Hospice Physician",
                value: HosDisciplineEnum["Hospice Physician"]
            }
        ],

        [
            "Medical Social Work",
            {
                name: "Medical Social Work",
                value: HosDisciplineEnum["Medical Social Work"]
            }
        ],
        [
            "Spiritual Counseling",
            {
                name: "Spiritual Counseling",
                value: HosDisciplineEnum["Spiritual Counseling"]
            }
        ],
        [
            "Bereavement Counseling",
            {
                name: "Bereavement Counseling",
                value: HosDisciplineEnum["Bereavement Counseling"]
            }
        ],
        [
            "Volunteer Coordinator",
            {
                name: "Volunteer Coordinator",
                value: HosDisciplineEnum["Volunteer Coordinator"]
            }
        ],
        [
            "Physical Therapy",
            {
                name: "Physical Therapy",
                value: HosDisciplineEnum["Physical Therapy"]
            }
        ],
        [
            "Occupational Therapy",
            {
                name: "Occupational Therapy",
                value: HosDisciplineEnum["Occupational Therapy"]
            }
        ],
        [
            "Speech Therapy",
            {
                name: "Speech Therapy",
                value: HosDisciplineEnum["Speech Therapy"]
            }
        ],
        [
            "Reiki",
            {
                name: "Reiki",
                value: HosDisciplineEnum.Reiki
            }
        ],
        [
            "Music Therapy",
            {
                name: "Music Therapy",
                value: HosDisciplineEnum["Music Therapy"]
            }
        ],
        [
            "Art Therapy",
            {
                name: "Art Therapy",
                value: HosDisciplineEnum["Art Therapy"]
            }
        ],
        [
            "Massage Therapy",
            {
                name: "Massage Therapy",
                value: HosDisciplineEnum["Massage Therapy"]
            }
        ],
        [
            "Aroma Therapy",
            {
                name: "Aroma Therapy",
                value: HosDisciplineEnum["Aroma Therapy"]
            }
        ],
        [
            "Healing Touch",
            {
                name: "Healing Touch",
                value: HosDisciplineEnum["Healing Touch"]
            }
        ],
        [
            "Hypnotherapy",
            {
                name: "Hypnotherapy",
                value: HosDisciplineEnum.Hypnotherapy
            }
        ],
        [
            "Pet Therapy",
            {
                name: "Pet Therapy",
                value: HosDisciplineEnum["Pet Therapy"]
            }
        ],
        [
            "Dietary Counseling",
            {
                name: "Dietary Counseling",
                value: HosDisciplineEnum["Dietary Counseling"]
            }
        ],
        [
            "Volunteer",
            {
                name: "Volunteer",
                value: HosDisciplineEnum.Volunteer
            }
        ],
        [
            "Hospice Aide",
            {
                name: "Hospice Aide",
                value: HosDisciplineEnum["Hospice Aide"]
            }
        ],
        [
            "Order",
            {
                name: "Order",
                value: HosDisciplineEnum.Order
            }
        ],
        [
            "Complementary Therapy",
            {
                name: "Complementary Therapy",
                value: HosDisciplineEnum["Complementary Therapy"]
            }
        ],
        [
            "Hospice Medical Director",
            {
                name: "Hospice Medical Director",
                value: HosDisciplineEnum["Hospice Medical Director"]
            }
        ],
        [
            "Physician’s Assistant",
            {
                name: "Physician’s Assistant",
                value: HosDisciplineEnum["Physician’s Assistant"]
            }
        ],
        [
            "Home Maker",
            {
                name: "Home Maker",
                value: HosDisciplineEnum["Home Maker"]
            }
        ],
        [
            "Nurse Practitioner",
            {
                name: "Nurse Practitioner",
                value: HosDisciplineEnum["Nurse Practitioner"]
            }
        ]
    ]);
}

export const HosDiscipline = new HosDisciplineClass();
